import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MatDialog } from '@angular/material';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { UserData } from '../models/UserData';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { HttpHelpersService } from './http-helpers.service';
import { LOGIN_URL, LOGOUT_URL, USER_API_URL , CONNECT_API, LICENSE_VERSION, TERM_STORAGE } from '../consts/appConsts';
import { TokenService } from './token.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { USER_INFO , CREATE_SESSION, GET_LICENSE_VERSION } from '../consts/apiMethods';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    $userData: BehaviorSubject<UserData> = new BehaviorSubject(undefined);
    $beforeLogin = new Subject<boolean>();
    $loginOpened = new Subject<boolean>();
    userData: UserData;
    constructor(
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private location: Location,
        private httpHelperService: HttpHelpersService,
        private tokenService: TokenService
    ) {}

    openLogin(): Observable<UserData> {
        this.$beforeLogin.next(true);
        const token = this.tokenService.token;
        return this.openDialog(token);
    }


    private openDialog(token: any): Observable<UserData> {
        this.$loginOpened.next(true);
        const dialogRef = this.dialog.open(LoginDialogComponent, {
            autoFocus: true,
            width: '100%',
            hasBackdrop: false,
            panelClass: 'login-dialog',
            data: { url: LOGIN_URL, token: token },
            position: { top: '50px', left: '0', right: '0' },
        });
        dialogRef.beforeClose().subscribe((data: UserData) => {
            this.$loginOpened.next(false);
            if (data) {
                this.tokenService.setToken(data.token);
                this.tokenService.resetTmpToken();
                this.$userData.next(data);
                this.userData = data;
            }
        });
        return this.$userData.asObservable();
    }

    getUser() {
        if (this.userData) {
            return;
        }
        return this.httpHelperService
            .ajax(
                'get',
                { method: USER_INFO, channel: 'online' },
                USER_API_URL,
                null,
                false,
                environment.baseConnectApi
            )
            .pipe(
                map(response => {
                    return response.payLoad;
                })
            )
            .subscribe((userData: UserData) => {
                if (userData && userData.isRegister) {
                    this.$userData.next(userData);
                    this.userData = userData;
                }
            });
    }

    openLogout(): Observable<any> {
        this.$beforeLogin.next(true);
        const token = this.tokenService.token;
        return this.openLogoutDialog(token);
    }
    private openLogoutDialog(token: any): Observable<any> {
        const dialogRef = this.dialog.open(LoginDialogComponent, {
            autoFocus: true,
            width: '100%',
            hasBackdrop: false,
            panelClass: 'login-dialog',
            data: { url: LOGOUT_URL, token: token },
            position: { top: '50px', left: '0', right: '0' },
        });
        localStorage.removeItem('LUPA_TOKEN')
        return dialogRef.beforeClose();
    }
    clearUserData() {
        this.$userData.next(null);
    }

    getLicenseVersion() {
        return this.httpHelperService.ajax('get', { method: GET_LICENSE_VERSION },USER_API_URL,null,false, environment.baseConnectApi)        
        .subscribe(res=> 
            {
                let currLicenseVersion = localStorage.getItem(LICENSE_VERSION);
                if (currLicenseVersion != res.payLoad) {
                    localStorage.setItem(TERM_STORAGE, "false");
                    localStorage.setItem(LICENSE_VERSION, res.payLoad);
                }
            });
    }
}
